/*
 * @Author: Tarzan
 * @Date: 2021-08-09 10:46:11
 * @LastEditTime: 2021-08-11 14:51:23
 * @LastEditors: Tarzan
 * @Description:
 * @FilePath: \jyedit-managed:\0job\project\jyedit-pc\src\api\goodsCart.js
 */
import request from '@/utils/request'
/**
 * 获取购物车商品列表
 */
export function goodsCartList() {
	return request({
		url: '/member/wap/goods/goodsCart',
		method: 'get',
		data:{}
	})
}

/**
 * 删除选中
 */
export function deleteSelect(data) {
	return request({
		url: '/member/wap/goods/deleteGoodsCart',
		method: 'post',
		data
	})
}
/**
 *去结算
 */
export function createTempOrder(data) {
	return request({
		url: 'member/wap/goods/createTempOrder',
		method: 'post',
		data
	})
}

//购物车中为你推荐
export function likeGoods() {
	return request({
		url: 'wap/home/cnxh',
		method: 'get'
	})
}

//修改商品数量  type(0 减 1加 )  id  num   
export function changeCounts(data){
	return request({
		// url: 'member/wap/goods/goodsCart/changeCounts',
		url: 'member/wap/goods/addSubNum',
		method: 'post',
		data
	})
}

//购物车商品总数量
export function goodsCartCountsTotal(){
	return request({
		// url: 'member/wap/goods/goodsCart/counts',
		url: 'member/wap/goods/goodsCartNum',
		method: 'get'
	});
}

// 配赠余额
export function checkMoney(params){
	return request({
		url: 'member/wap/gift/goods/check_money',
		method: 'get',
		params
	});
}

